module.exports = "https://img.xiyuyouxi.com/saas/img/rmb_icon.7b041e32.png";